import { render, staticRenderFns } from "./PostGallary.vue?vue&type=template&id=427f82e2&scoped=true&"
import script from "./PostGallary.vue?vue&type=script&lang=js&"
export * from "./PostGallary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427f82e2",
  null
  
)

export default component.exports